import { PhoneOrderDraftCreateInput } from '@/features/graphql/generated/graphql'
import { phoneOrderDraftMutation } from '@/features/pos/components/OrderFinalization/mutations'
import { logger } from '@/features/pos/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { useMutation } from '@apollo/client'
import { useCallback } from 'react'

export const usePhoneOrderDraft = (): [
    (cartKey: string, orderData: PhoneOrderDraftCreateInput) => Promise<void>,
    boolean,
] => {
    const handleError = useHandleErrorWithToast(logger)

    const [phoneOrderDraft, { loading }] = useMutation(phoneOrderDraftMutation, {
        onError: handleError,
    })

    const handleOrderDraft = useCallback(
        async (cartKey: string, orderData: PhoneOrderDraftCreateInput) => {
            await phoneOrderDraft({ variables: { cartKey, orderData } })
        },
        [phoneOrderDraft]
    )

    return [handleOrderDraft, loading]
}
